import { Component } from '@angular/core';

@Component({
  selector: 'app-osm-map-one',
  templateUrl: './osm-map-one.component.html',
  styleUrls: ['./osm-map-one.component.css']
})
export class OsmMapOneComponent {

}
